import swaggerClient from "../remote-client";
import Utils from "../Utils";

export default class PasswordRecoveryServiceImpl {
  passwordRecovery(payload) {
    return swaggerClient.userSwaggerClient
      .then(
        client => {
          return client.apis.UserHealthFacility.postHfUserRecoverPassword(
            {},
            swaggerClient.buildRequest(payload),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        result => {
          return result.body;
        },
        reason => {
          return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
        }
      );
  }

  usernameRecovery(payload) {
    return swaggerClient.userSwaggerClient
      .then(
        client => {
          return client.apis.UserHealthFacility.postHfUserRecoverUsername(
            {},
            swaggerClient.buildRequest(payload),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        result => {
          return result.body;
        },
        reason => {
          return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
        }
      );
  }

  newPassword(payload) {
    return swaggerClient.userSwaggerClient
      .then(
        client => {
          return client.apis.UserHealthFacility.postHfUserNewPassword(
            {},
            swaggerClient.buildRequest(payload),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        result => {
          return result.body;
        },
        reason => {
          return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
        }
      );
  }

  changePassword() {
    return swaggerClient.hfportalSwaggerClient
      .then(
        client => {
          return client.apis.HFLoginService.changePassword(
            {},
            swaggerClient.buildRequest(),
            {}
          );
        },
        error => {
          return Promise.reject({
            type: Utils.errorTypes.UNABLE_TO_CALL_API,
            reason: error
          });
        }
      )
      .then(
        result => {
          return result.body;
        },
        reason => {
          return Promise.reject({ type: Utils.errorTypes.STATUS, reason });
        }
      );
  }
}
